module.exports = __webpack_public_path__ + "img/topbar.eac2bd33.png";